import { render, staticRenderFns } from "./VideosItemView.vue?vue&type=template&id=8aa8d572&scoped=true&"
import script from "./VideosItemView.vue?vue&type=script&lang=js&"
export * from "./VideosItemView.vue?vue&type=script&lang=js&"
import style0 from "./VideosItemView.vue?vue&type=style&index=0&id=8aa8d572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa8d572",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VRow,VSheet})
